<template>
  <div v-if="items.length" class="page-home-videos mb-4">
    <Title>Vídeos</Title>
    <div class="page-home-videos-list mt-4">
      <VideoCard
        v-for="({ id, title, link }, i) in items"
        :key="i"
        :id="id"
        :title="title"
        :link="link"
        :type="getCardTypeFromIndex(i)"
      ></VideoCard>
    </div>
    <div class="d-flex justify-center mt-4">
      <v-btn
        :to="path"
        color="primary"
        class="rounded-pill text-capitalize px-4"
        depressed
        >Mais Vídeos</v-btn
      >
    </div>
  </div>
</template>

<script>
import Title from "@/components/widgets/Title.vue";
import VideoCard from "@/components/cards/Video.vue";

const _config = {
  mod: "videos",
  path: "/videos",
};

export default {
  data: () => ({
    path: _config.path,
  }),
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    md() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  methods: {
    formatDate(str) {
      const dateTimeFormat = new Intl.DateTimeFormat("pt-BR", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });

      return dateTimeFormat.format(new Date(str.replace(/\s/, "T")));
    },
    getCardTypeFromIndex(i) {
      let r;

      if (i < 1) r = "x-large";
      else if (i < 3 && !this.md) r = "large";
      else r = "normal";

      return r;
    },
  },
  mounted() {
    const itemsPerPage = this.xs ? 5 : 7;

    this.$rest(_config.mod).get({ params: { itemsPerPage } });
  },
  components: {
    Title,
    VideoCard,
  },
};
</script>


<style>
.page-home-videos-list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto;
  gap: 24px;
}
.page-home-videos-list > :nth-child(1) {
  grid-column-end: span 2;
  grid-row-end: span 2;
}

.page-home-videos-list > :nth-child(2),
.page-home-videos-list > :nth-child(3) {
  grid-column-end: span 2;
}

@media screen and (max-width: 1264px) {
  .page-home-videos-list > * {
    grid-row-end: span 1 !important;
    grid-column-end: span 1 !important;
  }
}

@media screen and (max-width: 600px) {
  .page-home-videos-list {
    grid-template-columns: 1fr 1fr;
  }
  .page-home-videos-list > :nth-child(1) {
    grid-column-end: span 2 !important;
  }
}
</style>
